import { ReactNode } from 'react'
import { styled, Typography } from '@mui/material'

// Table cell text shared by the income tables, matching the other customer-page tables.
export const cell = (value?: ReactNode) => <StyledText>{value ?? ''}</StyledText>

const StyledText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  textAlign: 'inherit',
  color: theme.palette.secondary.main,
}))
